<template>
  <div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          class="table"
          style="width: 100%"
          v-loading="loading"
          default-expand-all
          ref="table"
          row-key="order_id"
        >
          <el-table-column label="图片" width="60">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  style="width: 65px; height: 65px"
                  :src="scope.row.product[0].image.file_path"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="user_id" label="订单信息" width="230">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center">
                <div
                  class="product-info"
                  v-for="(item, index) in scope.row.product"
                  :key="index"
                >
                  <div class="disf">
                    <div
                      v-if="
                        item.product_attr.indexOf('不') != -1 &&
                          item.product_attr.indexOf('保障服务')
                      "
                    ></div>
                    <div v-else>
                      <span
                        v-if="item.product_attr.indexOf('保障服务') != -1"
                        class="bzfw"
                        >已投碎屏险保障</span
                      >
                    </div>
                    <div v-if="scope.row.car_lease" class="carBox">
                      以租代购
                    </div>
                    <div class="c_main">订单号：{{ scope.row.order_no }}</div>
                    <div class="name gray3 product-name">
                      <span>{{ item.product_name }}</span>
                    </div>
                    <div class="gray9" v-if="item.product_attr">
                      {{ item.product_attr }}
                    </div>

                    <div class="leasetype">{{ scope.row.lease_type }}</div>

                    <div class="orange" v-if="item.refund">
                      {{ item.refund.type.text }}-{{ item.refund.status.text }}
                    </div>
                    <div>
                      数量: <span class="juz"> x {{ item.total_num }} </span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="付款信息" width="200">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span style="color: #3498db">
                总租金:<span class="fontwb"
                  >￥{{ scope.row.bill_price.toFixed(2) }}</span
                >
              </span>
              <p class="">
                买断价:<span class="fontwb"
                  >￥{{ scope.row.new_buy_out_price }}</span
                >
              </p>
              <p class="">
                优惠:<span class="fontwb">￥{{ scope.row.coupon_money }}</span>
              </p>
              <p class="">
                已还租:<span style="color: #3498db"
                  >￥{{ scope.row.pricezq }}</span
                >
              </p>
              <p style="color: #3498db">
                已付:<span style="color: #3498db">￥0 详情</span>
              </p>
              <!-- <p style="display: flex; flex-direction: column;">
                <span style="display: flex; align-items: center;  min-width: 170px;font-size: 13px;">
                  <span>合计进货价：</span>
                  <div v-if="isType(scope.row.purchase) == 'string'">
                    {{scope.row.purchase}}￥
                    <i class="el-icon-edit-outline" style="font-size: 16px;" @click="btnEdit(scope.row)"></i>
                  </div>

                  <el-input-number v-model="scope.row.purchase" :min="0" size="small" controls-position="right" v-else-if="isType(scope.row.purchase) != 'string'" />
                </span>
              <p style="margin-top: 10px;" v-if="isType(scope.row.purchase) != 'string'">
                <el-button size="mini" type="info" round @click="btnSave(scope.row)">保 存</el-button>
                <el-button size="mini" round @click="getData()">取 消</el-button>
              </p>
              </p> -->
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="预交租金" width="170">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <p class="">
                预授权+预交租金:<span class="fontwb"
                  >￥{{ scope.row.yujyj }}</span
                >
              </p>
              <div class="">
                预交租金:<span class="fontwb">￥{{ scope.row.yushou }}</span>
              </div>
              <div class="">
                预授权押金总额:<span class="fontwb"
                  >￥{{ scope.row.ysqyjze }}</span
                >
              </div>
              <div class="">
                信用免押:<span style="color: red">￥0.00</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="买家" width="280">
            <template
              slot-scope="scope"
              v-if="!scope.row.is_top_row && scope.row.user"
            >
              <div class="fwbold">
                <div class="xxflex">
                  租户姓名：
                  <span class="usercolor">
                    {{ scope.row.username ? scope.row.username : "null" }}
                  </span>
                  / 年龄：
                  <span class="usercolor" v-if="scope.row.usernum"
                    >{{ scope.row.usernum | getsfz }}
                  </span>
                  <span class="usercolor" v-else> null </span>
                </div>
                <div>租户昵称：{{ scope.row.user.nickName }}</div>
                <div>
                  身份证号：{{
                    scope.row.usernum ? scope.row.usernum : ""
                  }}
                  (<span v-if="scope.row.hasrenzheng == 1">已认证</span>
                  <span
                    v-else
                    style="color: #ff1e10; font-weight: bold; font-size: 14px"
                    >未认证</span
                  >)
                </div>
                <div>
                  手机号：{{
                    scope.row.user.mobile ? scope.row.user.mobile : ""
                  }}
                </div>
                <div style="color: #3498db;">在租：{{ scope.row.renting }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="state_text" label="交易状态" width="100">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div class="dotg"></div>
                <div style="color: #18bc9c; margin-left: 3px">
                  {{
                    scope.row.order_status.value == 40
                      ? "已驳回"
                      : scope.row.state_text
                  }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="state_text" label="用户地址" width="220">
            <template
              slot-scope="scope"
              v-if="!scope.row.is_top_row && scope.row.user"
            >
              <div v-if="scope.row.address">
                收货地址:
                <span>{{ scope.row.address.region.province }}</span>
                <span>{{ scope.row.address.region.city }}</span>
                <span>{{ scope.row.address.region.region }}</span>
                <span>{{ scope.row.address.detail }}</span>
              </div>
              <div>下单IP:{{ scope.row.ip }}</div>
              <div>
                下单地区:{{ scope.row.province }} {{ scope.row.city }}
                {{ scope.row.district }} {{ scope.row.address_detail }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="is_comment" label="退款状态" width="110">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>
                <span>{{ scope.row.tuikuanzhauntai }}</span>
                <div v-if="scope.row.tuikuanzhauntai == '失败'">
                  <span>
                    <span class="green">预收错误：</span>
                    {{
                      scope.row.ys_fail_msg ? scope.row.ys_fail_msg : "无"
                    }}</span
                  >
                  <br />
                  <span>
                    <span class="green">押金错误：</span
                    >{{
                      scope.row.yj_fail_msg ? scope.row.yj_fail_msg : "无"
                    }}</span
                  >
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="120">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="czbutton">
                <div>
                  <el-button
                    @click="gofenpei(scope.row)"
                    type="primary"
                    size="mini"
                    style="width: 90px"
                    >订单认领</el-button
                  >
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes,prev, pager, next, jumper"
          :total="totalDataNumber"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";

export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1
    };
  },
  created() {
    this.getData();
  },
  methods: {
    gofenpei(row) {
      console.log(row);
      let self = this;
      self
        .$confirm("确定要继续操作?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info "
        })
        .then(() => {
          let Params = {
            order_id: row.order_id
          };
          OrderApi.indexBind(Params, true)
            .then(res => {
              self.getData();
              self.$message({
                message: "操作成功",
                type: "success"
              });
            })
            .catch(error => {});
        })
        .catch(() => {
          self.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    isType(purchase) {
      return typeof purchase;
    },
    /*获取数据*/
    getData() {
      let self = this;
      let Params = {
        page: self.curPage, // 多少条
        list_rows: self.pageSize // 第几页
      };
      self.loading = true;
      OrderApi.indexList(Params, true).then(res => {
        self.loading = false;
        console.log(res.data.data, "table");
        self.tableData = res.data.data;
        self.totalDataNumber = res.data.total;
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      console.log(val);
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      self.loading = true;
      this.getData();
    },
  },
    filters: {
      delivery(e) {
        if (e == "10001") {
          return "顺丰快递";
        }
        if (e == "10002") {
          return "邮政国内";
        }
        if (e == "10003") {
          return "圆通速递";
        }
        if (e == "10004") {
          return "申通快递";
        }
        if (e == "10005") {
          return "韵达快递";
        }
        if (e == "10006") {
          return "百世快递";
        }
        if (e == "10007") {
          return "中通快递";
        }
        return "暂无";
      },
      // 过滤器
      formatDate(value) {
        let date = new Date(value * 1000);
        //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM; //月补0
        let d = date.getDate();
        d = d < 10 ? "0" + d : d; //天补0
        let h = date.getHours();
        h = h < 10 ? "0" + h : h; //小时补0
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m; //分钟补0
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s; //秒补0
        // return y + '-' + MM + '-' + d; //年月日
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //年月日时分秒
      },
      // 身份证换算成年龄
      getsfz(iden) {
        if (iden !== null) {
          let val = iden.length;
          let myDate = new Date();
          let month = myDate.getMonth() + 1;
          let day = myDate.getDate();
          let age = 0;

          if (val === 18) {
            age = myDate.getFullYear() - iden.substring(6, 10) - 1;

            if (
              iden.substring(10, 12) < month ||
              (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
            )
              age++;
          }
          if (val === 15) {
            age = myDate.getFullYear() - iden.substring(6, 8) - 1901;

            if (
              iden.substring(8, 10) < month ||
              (iden.substring(8, 10) == month && iden.substring(10, 12) <= day)
            )
              age++;
          }
          return age;
          // this.age = age;
        }
      }
    }
  
};
</script>

<style lang="scss" scoped>
.el-date-editor .el-range-separator {
  padding: 0 5px;
  line-height: 32px;
  width: 11% !important;
  color: #303133;
}
.unfold-fold {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#searchBox {
  overflow: hidden;
}

.el-input-number--small {
  width: 90px;
  line-height: 30px;
}

.el-dropdown-menu__item + .el-dropdown-menu__item {
  margin-top: 5px;
}

// 以租代购样式
.carBox {
  background-color: #5e8f78;
  color: white;
  padding: 2px 10px;
  width: 70px;
  text-align: center;
}

.el-table__expanded-cell {
  padding: 0 !important;
}

.control {
  padding: 10px 20px;
  display: flex;
  border-bottom: #ebeef5 solid 1px;

  & > div {
    margin-right: 10px;
  }
}

.Goodstype {
  display: flex;
  padding: 20px;

  div {
    margin: 0 10px;
  }
}

.dotg {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #18bc9c;
}

.bzfw {
  color: #3722c2;
  background: #ddd8ff;
  font-size: 12px;
  padding: 2px 10px;
}

.leasetype {
  background-color: #a894a6;
  color: white;
  padding: 2px 10px;
  width: 70px;
  text-align: center;
}

.fontwb {
  font-weight: bold;
}

.mr {
  margin: 20px 30px;
}

.fwbold {
  font-weight: bold;
  font-size: 13px;
}

.d1 {
  width: 100px;
  list-style: none;
  border: 1px solid #ffa49f;
  padding: 5px;
  background-color: #fff1f0;
  color: #f6363e;
  border-radius: 10px;
  text-align: center;
  margin: 25px 0;
}

.czbutton div {
  margin-bottom: 3px;
}

.anniu1 {
  margin-bottom: 3px;
}

.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.disf {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}

.xiegang {
  color: #18bc9c;
  margin: 0 5px;
}

.xxflex {
  display: flex;
}

.usercolor {
  color: #3498db;
  font-weight: bold;
}

.juz {
  white-space: normal;
  color: #3498db;
}

.juz2 {
  white-space: normal;
  color: #e74c3c;
}

.juz3 {
  white-space: normal;
  color: #f39c12;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.sanyaosu {
  text-align: center;
  font-size: 20px;
  margin: 10px;
}

.qianshu {
  font-size: 20px;
  color: red;
}

.zhangdantable {
  border-collapse: collapse;
  width: 380px;
  text-align: center;

  tr {
    height: 30px;
  }
}

.cont-cope {
  width: 100%;
  height: 120px;
  border-radius: 5px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/flowpoo.vue